import DefaultLayout from '@components/layout/layout/DefaultLayout';
import Advisors from '../index/fsm/Advisors';
import BillOfRights from './BillOfRights';
import CallUs from './CallUs';
import FAQS from '../index/fsm/FAQS';
import News from '../index/fsm/News';
import Reviews from '../index/fsm/Reviews';
import WhatToExpect from '../index/fsm/WhatToExpect';
import Clients from './Clients';
import Hero from './Hero';

const MedicareBrokers = () => {
  return (
    <DefaultLayout>
      <Hero />
      <Reviews />
      <Clients />
      <BillOfRights />
      <WhatToExpect />
      <Advisors />
      <News />
      <FAQS />
      <CallUs />
    </DefaultLayout>
  );
};

export default MedicareBrokers;
